import { Routes } from '@angular/router';
import { Tracking } from './tracking/tracking';

export const routes: Routes = [{ path: '', component: Tracking }];
